// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/',
};

// ----------------------------------------------------------------------

export const paths = {
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    login: `${ROOTS.AUTH}/login`,
    forgetPassword: `${ROOTS.AUTH}/forget-password`,
    resetPassword: `${ROOTS.AUTH}/reset-password`,
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    load: {
      list: `${ROOTS.DASHBOARD}loads`,
      create: `${ROOTS.DASHBOARD}loads/create/`,
    },
    loadManagement: {
      list: `${ROOTS.DASHBOARD}load-management`,
    },
    trip: {
      list: `${ROOTS.DASHBOARD}trips`,
      create: `${ROOTS.DASHBOARD}trips/create/`,
      trackingDetail: `${ROOTS.DASHBOARD}trips/tracking/`,
    },
    carrier: {
      list: `${ROOTS.DASHBOARD}carriers`,
      create: `${ROOTS.DASHBOARD}carriers/create`,
    },
    referralCode: {
      list: `${ROOTS.DASHBOARD}referral-code`,
      create: `${ROOTS.DASHBOARD}referral-code/create`,
    },
    discount: {
      list: `${ROOTS.DASHBOARD}discount`,
      create: `${ROOTS.DASHBOARD}discount/create`,
    },
    subscriptionPlan: {
      list: `${ROOTS.DASHBOARD}settings/subscription-plans`,
      create: `${ROOTS.DASHBOARD}settings/subscription-plans/create`,
      buy: `${ROOTS.DASHBOARD}subscription-plans/buy/`,
    },
    role: {
      list: `${ROOTS.DASHBOARD}role`,
      create: `${ROOTS.DASHBOARD}role/create`,
    },
    truck: {
      list: `${ROOTS.DASHBOARD}trucks`,
      create: `${ROOTS.DASHBOARD}trucks/create`,
      report: `${ROOTS.DASHBOARD}trucks/report/`,
      createCost: `${ROOTS.DASHBOARD}trucks/costs/create/`,
    },
    requestCarrier: {
      list: `${ROOTS.DASHBOARD}request-carrier/list`,
    },
    carrierLanes: {
      list: `${ROOTS.DASHBOARD}carrier-lanes`,
    },
    shippers: {
      list: `${ROOTS.DASHBOARD}shippers`,
    },
    brokerProfiles: {
      carriersList: `${ROOTS.DASHBOARD}broker/carriers`,
      carrierDetail: (carrierId: number) =>
        `${ROOTS.DASHBOARD}broker/carriers/${carrierId}`,
      shippersList: `${ROOTS.DASHBOARD}broker/shippers`,
      shipperDetail: (shipperId: number) =>
        `${ROOTS.DASHBOARD}broker/shippers/${shipperId}`,
    },
    brokerEmails: {
      list: `${ROOTS.DASHBOARD}emails`,
    },
    mailbox: {
      list: `${ROOTS.DASHBOARD}mail-box`,
      thread: (threadId: string) =>
        `${ROOTS.DASHBOARD}mail-box/thread/${threadId}`,
    },
    dispatcher: {
      list: `${ROOTS.DASHBOARD}dispatchers`,
      create: `${ROOTS.DASHBOARD}dispatchers/create`,
    },
    transactions: `${ROOTS.DASHBOARD}report/transactions`,
    driver: {
      list: `${ROOTS.DASHBOARD}drivers`,
      create: `${ROOTS.DASHBOARD}drivers/create`,
    },
    report: {
      driver: `${ROOTS.DASHBOARD}report/drivers-activity`,
      dispatcher: `${ROOTS.DASHBOARD}report/dispatchers-activity`,
      unverifiedUsers: `${ROOTS.DASHBOARD}report/users`,
      carrierReport: `${ROOTS.DASHBOARD}report/carriers-activity`,
    },
    content: {
      helperList: `${ROOTS.DASHBOARD}content/helpers`,
      helperCreate: `${ROOTS.DASHBOARD}content/helpers/create/`,
      sliderList: `${ROOTS.DASHBOARD}content/sliders`,
      sliderCreate: `${ROOTS.DASHBOARD}content/sliders/create/`,
    },
    brokerLoad: {
      list: `${ROOTS.DASHBOARD}broker-loads`,
      awaitingQuote: `${ROOTS.DASHBOARD}broker-loads/awaiting-quote`,
      workflowConfig: `${ROOTS.DASHBOARD}broker-loads/workflow-config`,
      checkpoints: `${ROOTS.DASHBOARD}broker-loads/checkpoints`,
      checkpointDetail: (checkpointId: number) =>
        `${ROOTS.DASHBOARD}broker-loads/checkpoints/${checkpointId}`,
      detail: `${ROOTS.DASHBOARD}broker-loads/`,
      loadTempDetail: (loadTempId: number) =>
        `${ROOTS.DASHBOARD}broker-loads/load-temp/${loadTempId}`,
      carrierOffers: (loadId: number) =>
        `${ROOTS.DASHBOARD}broker-loads/${loadId}/carrier-offers`,
      gmailThread: (loadId: number, threadId: number) =>
        `${ROOTS.DASHBOARD}broker-loads/${loadId}/gmail-threads/${threadId}`,
      loadTempGmailThread: (loadTempId: number, threadId: number) =>
        `${ROOTS.DASHBOARD}broker-loads/load-temp/${loadTempId}/gmail-threads/${threadId}`,
      tracking: (loadId: number) =>
        `${ROOTS.DASHBOARD}broker-loads/${loadId}/tracking`,
    },
    changeRoleAndCarrier: `${ROOTS.DASHBOARD}change-role-carrier`,
    calculator: `${ROOTS.DASHBOARD}calculator`,
    selectUnlockItems: `${ROOTS.DASHBOARD}select-unlock-items`,
  },
};
